import { parseApiDate } from '@webapp/core';
import { ApiKey } from '../interfaces/api-keys.interface';

export const MAX_ACTIVE_API_KEYS = 3;

export const isApiKeyExpired = (key: ApiKey, now: Date): boolean =>
	key.expiresAt !== null && parseApiDate(key.expiresAt) <= now;
